module.exports = __webpack_public_path__ + "static/image/history/pc/202010@3x.ver2_0_2.jpg?471c13b2";